import React from 'react'
import { connect } from 'react-redux'
import styles from './RideCondensedStats.scss'
import { Distance, Elevation, Speed, Duration } from 'common/units'
import { TripThumb } from 'common/ListItems'
import { CoreLink } from 'common/CoreLink'
import { HighlightedPhoto } from 'common/ListItems/HighlightedPhoto'
import { Icon } from 'common/Icon'
import { DELETE_TROUTE_DIALOG } from 'common/dialogs/DeleteTRoute'
import { MobileCollapse } from 'common/layouts/SideNavLayout/SideNavContexts'
import { urls } from 'lib/urls'
import { j } from 'lib/textUtils'
import { readDateFormatFromPreferences } from 'lib/dateUtils'
import { Msg, fm, commonMetrics, commonVerbs, commonTRouteMessages, privacyLevels, timeLabels } from 'lib/localization'
import { experimentEnabled } from 'lib/utils'
import { tripSelectors } from 'data/resources/trips'
import cx from 'classnames'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

export class _RideCondensedStats extends React.PureComponent {
  onArrowClick = () => this.props.toggleItem(this.props.expandKey)

  render () {
    const { trip, expanded, expandKey, showDialog, checkbox, intl } = this.props
    const isExpanded = expanded.has(expandKey)

    const LinkComponent = chunks => experimentEnabled('trsp_redesign')
      ? <CoreLink {...chunks} />
      : <a {...chunks} />

    return (
      <div className={cx(styles.RideCondensedStats, isExpanded && styles.isExpanded)}>
        <Grid className={styles.mainGrid}>
          <MobileCollapse>{checkbox}</MobileCollapse>
          <Col className={styles.nameAndLocationCol} flex='7'>
            <h4><LinkComponent to={urls.trips.show(trip.id)} href={urls.trips.show(trip.id)} title={trip.name}>{trip.name}</LinkComponent></h4>
            <div className={styles.location}>
              <span data-tip title={fm(intl, commonTRouteMessages.startLocation)}>
                {j([trip.locality, trip.administrativeArea])}
              </span>
            </div>
          </Col>
          <Col className={styles.rideStatsCol} flex={3 * 6}>
            <RideStats trip={trip} intl={intl} />
          </Col>
          <Col className={styles.actionsCol} flex='0 0 auto' alignRight>
            <div className={styles.actionsIcons}>
              <a href={`/trips/${trip.id}/edit`}>
                <Icon
                  className={styles.actionsIcon}
                  data-tip
                  title={fm(intl, commonVerbs.edit)}
                  i='md-create'
                  size={20} />
              </a>
              <Icon
                onClick={() => showDialog(DELETE_TROUTE_DIALOG)}
                data-tip
                title={fm(intl, commonVerbs.delete)}
                i='md-trash'
                size={20}
                className={styles.actionsIcon} />
            </div>
          </Col>
          <Col className={styles.thumbnailsCol} flex='0 0 92px' alignRight>
            <HighlightedPhoto photoId={trip.highlightedPhotoId} parentType={'trip'} parentId={trip.id} readonly={false} style={{ height: '40px', width: '40px' }} />
            <TripThumb size={40} trip={trip} />
          </Col>
          <MobileCollapse>
            <Col className={styles.expandIconCol} flex='0 0 auto' alignRight>
              <div className={styles.expandClickTarget} onClick={this.onArrowClick}>
                <Icon i={'ios-arrow-down'} size={22} className={cx(styles.expandIcon, isExpanded && styles.expanded)} />
              </div>
            </Col>
          </MobileCollapse>
        </Grid>
      </div>
    )
  }
}

const RideStats = ({ trip, intl }) => (
  <div className={styles.RideStats}>
    <Grid className={styles.statGrid}>
      <Col>
        <span data-tip title={fm(intl, commonMetrics.distance)}>
          <Distance short value={trip.distance} />
        </span>
      </Col>
      <Col>
        <span data-tip title={_.startCase(fm(intl, commonMetrics.elevationGain))}>
          <Elevation short value={trip.elevationGain} />
        </span>
      </Col>
      <Col>
        <span data-tip title={`${fm(intl, commonMetrics.movingTime)} (${fm(intl, timeLabels.hhmm)})`}>
          {typeof trip.movingTime === 'string' || trip.movingTime === null
            ? trip.movingTime
            : <Duration value={trip.movingTime} valueOnly bigUnits />}
        </span>
      </Col>
      <Col>
        <span data-tip title={_.startCase(fm(intl, commonMetrics.avgSpeed))}>
          {trip.avgSpeed && <Speed short value={trip.avgSpeed} />}
        </span>
      </Col>
      <Col>
        {trip.avgWatts
          ? <span data-tip title={fm(intl, commonMetrics.avgPower)}>{Math.round(trip.avgWatts)} <Msg m={commonMetrics.watts} /></span>
          : <span data-tip title={fm(intl, commonMetrics.avgPowerEst)}><em>{Math.round(trip.avgPowerEstimated)} <Msg m={commonMetrics.watts} /></em></span>}
      </Col>
      <Col>
        {!trip.visibility && fm(intl, privacyLevels.public)}
        {trip.visibility === 1 && fm(intl, privacyLevels.private)}
        {trip.visibility === 2 && fm(intl, privacyLevels.friendsOnly)}
      </Col>
    </Grid>
    <Grid className={styles.dateGrid}>
      <Col className={styles.dateCol} flex={undefined}>
        {moment(trip.departedAt).format(readDateFormatFromPreferences())}
      </Col>
    </Grid>
  </div>
)

const Grid = ({ className, children }) => (
  <div className={cx(styles.Grid, className)}>
    {children}
  </div>
)

const Col = ({ children, className, flex, alignRight, marginTop }) => {
  const margin = `${marginTop} 0 0 0` || ''
  return <div className={cx(styles.Col, className, alignRight && styles.alignRight)} style={{ flex: flex, margin: margin }}>
    {children}
  </div>
}

const mapStateToProps = (state, ownProps) => {
  return {
    trip: tripSelectors.find(state, ownProps.troute.id)
  }
}

export const RideCondensedStats = connect(
  mapStateToProps,
  null
)(injectIntl(_RideCondensedStats))
